<div class="container-fluid bg-white rounded pt-4 pb-3">
    <label class="form-label pb-2">{{ titleText | translate }}</label>
    <div class="row">
        <div class="col-xl-8 col-lg-9 col-md-8 col-12 mb-2">
            <forms #formNursery [formInfo]="formInfo" (filesSelected)="onFilesSelected($event)"></forms>
            <img class="promotion-media" *ngIf="promotionMediaUrl" [src]="promotionMediaUrl" />
        </div>
    </div>
    <button class="btn" [disabled]="!this.formComponent.form.valid" (click)="onSavePromotion()">
        {{ "PROMOTION_EDIT_COMPONENT_SAVE" | translate }}
    </button>
</div>
